import styled from 'styled-components';

const StateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .st-slider-field--title {
    font-family: Sofia Pro;
    font-size: 16px;
    line-height: 23px;
    color: var(--neutral-text-color);
    font-weight: 600;
  }

  .st-slider-field--helper {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    display: inline-block;
    border-radius: 50%;
    background: var(--blue-6);
    font-weight: bold;
    font-size: 13px;
    line-height: 22px;
    text-align: center;
    color: var(--white-color);
    margin-left: 10px;
    cursor: pointer;
    vertical-align: top;
  }

  .st-slider-helper {
    display: block;
    border: 1px solid var(--input-failed-color);
    background: var(--input-failed-color);

    height: 21px;
    font-size: 12px;
    line-height: 18px;
    top: -10px;
    left: 10px;
    padding: 1px 10px 0;
    color: var(--white-color);
  }

  .hidden {
    display: none;
  }
`;

export { StateContainer };
